import { useHistory } from "react-router-dom";
import { Typography } from "@mui/material";

import { InfoTooltip } from "../../../../Components/InfoTooltip/InfoTooltip";
import ActiveItemsCard from "../ActiveItemsCard";
import { useIsSupportUser } from "../hooks";
import { LoadingCard } from "../LoadingCard";
import { CreateItemCard } from "./CreateItemCard";

export const CommitmentsCard = ({
  activeCommitmentsAtRiskCount,
  costAtRisk,
  loading,
  totalCommitment,
  totalAmountOfActiveCommitments,
}: {
  activeCommitmentsAtRiskCount: number;
  costAtRisk: number;
  loading: boolean;
  totalCommitment: number;
  totalAmountOfActiveCommitments: number;
}) => {
  const history = useHistory();
  const isSupportUser = useIsSupportUser();
  if (loading) {
    return <LoadingCard title="Commitments" />;
  }

  const title = (
    <InfoTooltip
      cursor="default"
      description="Only applicable to current and active commitments. Calculated based on our forecasted estimate minus the total commitment amount."
    >
      <Typography variant="h4" color="text.primary" lineHeight={1.35}>
        Commitments at risk
      </Typography>
    </InfoTooltip>
  );

  if (activeCommitmentsAtRiskCount === 0 && totalCommitment === 0) {
    return (
      <CreateItemCard
        title={title}
        createMsg="You haven't set up any commitments yet"
        buttonLabel="Create a commitment"
        onButtonClick={() => {
          history.push("./monitor/commitment-manager/create");
        }}
        buttonDataCy="create-commitment-btn"
        disabled={isSupportUser}
      />
    );
  }

  if (activeCommitmentsAtRiskCount === 0) {
    return (
      <ActiveItemsCard
        title="Active commitments"
        value={totalAmountOfActiveCommitments}
        cloudCostsAtRisk={totalCommitment}
        buttonLink="./monitor/commitment-manager"
        dontConvert={true}
        riskLabel="Total commitment value"
        trend={0}
        trendColor="success.main"
        dataIcon="trending up"
        compactFormat={true}
        disabled={isSupportUser}
        trackingEvent="Active Commitments"
        trackingDescription="Review and Take Action button for commitments"
      />
    );
  }

  return (
    <ActiveItemsCard
      title={title}
      value={activeCommitmentsAtRiskCount}
      cloudCostsAtRisk={costAtRisk}
      dataIcon="trending down"
      trend="not on track to meet commitment"
      trendColor="error.main"
      riskLabel="Potential costs at risk"
      buttonLink="./monitor/commitment-manager"
      dontConvert={true}
      trackingEvent="Commitments at Risk"
      trackingDescription="Review and Take Action button for commitments at risk"
    />
  );
};
